import React from 'react';
import { MdSchool, MdInfo, MdCode, MdGroup } from 'react-icons/md';

const About = () => {
  return (
    <div className="bg-gray-50 rounded-lg">
      {/* Header */}
      <div className="bg-white shadow-sm border-b rounded-t-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="min-h-[72px] flex items-center">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-100 rounded-lg">
                <MdInfo className="text-blue-600 text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">About AI Assist</h1>
                <p className="text-gray-600 text-sm">Learn about our ERD learning platform</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Overview Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-bold text-2xl">AI</span>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">AI Assist ERD Learning Platform</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              A specialized learning management system designed for various Computer Science courses, combining AI-powered assistance with hands-on learning.
            </p>
          </div>
        </div>

        {/* Key Features */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-blue-100 rounded-lg">
                <MdSchool className="text-blue-600 text-xl" />
              </div>
              <h3 className="font-semibold text-gray-900">Interactive Learning</h3>
            </div>
            <p className="text-gray-600 text-sm">
              Hands-on ERD creation and validation with real-time feedback and AI-powered suggestions 
              to help students master database design concepts.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-blue-100 rounded-lg">
                <MdCode className="text-blue-600 text-xl" />
              </div>
              <h3 className="font-semibold text-gray-900">Document Management</h3>
            </div>
            <p className="text-gray-600 text-sm">
              Secure cloud-based storage for projects, assignments, and course materials 
              with version control and collaborative editing capabilities.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-blue-100 rounded-lg">
                <MdGroup className="text-blue-600 text-xl" />
              </div>
              <h3 className="font-semibold text-gray-900">Class Management</h3>
            </div>
            <p className="text-gray-600 text-sm">
              Streamlined class organization with role-based access for students and instructors, 
              assignment distribution, and progress tracking.
            </p>
          </div>
        </div>

        {/* About the System */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">About the Platform</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-semibold text-lg text-gray-900 mb-3">Purpose</h3>
              <p className="text-gray-600 mb-6">
                This platform was developed to enhance the process of learning CS concepts by providing 
                students and instructors with modern, interactive tools.
              </p>
              
              <h3 className="font-semibold text-lg text-gray-900 mb-3">Key Benefits</h3>
              <ul className="text-gray-600 space-y-2">
                <li>• Interactive ERD creation and validation tools</li>
                <li>• AI-powered learning assistance and feedback</li>
                <li>• Centralized assignment and project management</li>
                <li>• Real-time collaboration between students and instructors</li>
                <li>• Secure document storage and version control</li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold text-lg text-gray-900 mb-3">Technical Details</h3>
              <ul className="text-gray-600 space-y-2 mb-6">
                <li>• React-based responsive web interface</li>
                <li>• RESTful API backend architecture</li>
                <li>• Secure cloud document storage</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Version Information */}
        <div className="text-center py-6 border-t border-gray-200">
          <p className="text-gray-500 text-sm">
            AI Assist
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;